/**
 * Our implementation of Optimizely does not support app feature flags at the moment.
 * This class is intended to support a few legacy feature flags added to apps while
 * the legacy feature flags system is fully removed from the code base.
 * Ideally, the feature flags in this file should be considered a workaround and should
 * be removed at the first opportunity.
 * */

export class AppFeaturesStore {
  /**
   * legacy feature flag `build_extended_branch_search_depth`
   * created at 2019-10-23T16:58:17.000Z
   * @param appId The id of the application
   */
  public isBuildExtendedBranchSearchDepthActive(appId: string | undefined): boolean {
    if (!appId) {
      return false;
    }
    const enabledAppsInProd = [
      "9e7e2804-4c11-4716-8fd8-1576c22805bd",
      "eeb80c6c-fc4c-42ed-81d6-ac139d17aa43",
      "71a78a39-bfec-4fd3-94e2-6f4f06b6e2d2",
    ];
    return enabledAppsInProd.includes(appId);
  }
}

/**
 * @deprecated Consider using `optimizelyStore` instead
 */
export const appFeaturesStore = new AppFeaturesStore();
